
export const obscureEmail = (email, defaultValue = '') => {
    try {
        const hide = email.split('@')[0].length - 3
        const r = new RegExp('.{' + hide + '}@', 'g')
        return email.replace(r, '***@')
    } catch (e) {}

    return defaultValue
}

export const stringToBool = (value) => {
    if (value && typeof value === 'string') {
        if (value.toLowerCase() === 'true') return true
        if (value.toLowerCase() === 'false') return false
    }

    return value
}
